import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    standalone: false,
    name: 'toTitleCase',
    
})
export class ToTitleCasePipe implements PipeTransform {

  transform(value: string): string {
    if (!value || (value === '-')) return value;

    return value.split(' ').map(word => {
      return word
        .split('-')
        .map(part => part.charAt(0).toUpperCase() + part.substring(1).toLowerCase())
        .join(' ');
    }).join(' ');
  }

}
